import { render } from "./CategoryMenu.vue?vue&type=template&id=2bf33b96&scoped=true"
const script = {}

import "./CategoryMenu.vue?vue&type=style&index=0&id=2bf33b96&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf33b96"]])

export default __exports__